module.exports = __webpack_public_path__ + "static/media/home.ed19b452.svg";